import React, { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import BaseFilterPopover from './BaseFilterPopover';

// eslint-disable-next-line
const TextFilterPopover = ({ label, onApplyFilter }) => {
  const [textFieldValue, setTextFieldValue] = useState('');

  const handleTextFieldChange = (event) => {
    setTextFieldValue(event.target.value);
  };

  const handleOnApplyFilter = (value) => {
    onApplyFilter(value);
    setTextFieldValue('');
  };

  return (
    <BaseFilterPopover label={label} value={textFieldValue} onApplyFilter={handleOnApplyFilter}>
      <div style={{ padding: '16px', minWidth: 300 }}>
        <Typography gutterBottom>Text Search</Typography>
        <TextField
          label={label}
          value={textFieldValue}
          onChange={handleTextFieldChange}
          autoFocus
        />
      </div>
    </BaseFilterPopover>
  );
};

export default TextFilterPopover;
